import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import windowSize from "../libs/reactWindowSize";
import uuid from "uuid/v4";
import {withRouter} from "react-router-dom";

import ComponentRenderer from "./ComponentRenderer";
import { withScenePosition } from "../scenePosition";


let getMenuImagePath = (filename)=>{
  return `${window.public_url}/images/scenes/menu-images/${filename}`
};

class Menu extends Component {

  constructor(props){
    super(props);


    this.state = {
      id:  props.id || uuid()
    };
  }

  static getDerivedStateFromProps(props, state){

    return {
      ...state,
      image: getMenuImagePath(props.backgroundImage),
      components: props.components,
      id: props.id
    }
  }


  render() {

    const { image, components, id } = this.state;

    const { menu } = this.props;

    return (
      <Fragment>

        {menu.open && menu.id === id ?
          (<div className={`menu`} data-id={this.state.id}>
            <img alt="menu" src={image} />
            {components ? <ComponentRenderer components={components} /> : null }
            {this.props.children}
           </div>) : undefined
        }

      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step,
    tab: state.tab,
    menu: state.menu
  }
}

Menu.defaultProps = {
  selectedIndex: 0
}

export default withRouter(windowSize(connect(mapStateToProps)(withScenePosition(Menu))));



// WEBPACK FOOTER //
// ./src/components/Menu.jsx